import React from "react"

export const Label = ({ text, className, htmlFor }: { text: string, className?: string, htmlFor?: string }) => {
    return (
        <label className={className} htmlFor={htmlFor}>
            {text}
        </label>
    )
}
